import { useEffect, useState } from 'react';
import { farmAPI } from '@/lib/api';

// Crop Disease Check is live once the server has a Plantix key. Asked
// once per app load and shared by the home tile and the diagnosis page.
let pending = null;

export function diagnosisAvailable() {
  if (!pending) {
    pending = farmAPI.diagnosisConfig()
      .then((res) => Boolean(res.data?.available))
      .catch(() => {
        pending = null; // ask again next time
        return false;
      });
  }
  return pending;
}

/** null while asking, then true / false. */
export function useDiagnosisAvailable() {
  const [available, setAvailable] = useState(null);
  useEffect(() => {
    let alive = true;
    diagnosisAvailable().then((ok) => { if (alive) setAvailable(ok); });
    return () => { alive = false; };
  }, []);
  return available;
}
